import React from 'react';
import { getUniversalSearchFormLabel } from '../../common/helpers/get-usx-labels';
import { useEnabledFeatures } from '../../common/hooks/enabled-features';
import { WorkspacePanelButton } from '../../panels/workspace-panel-button';
import {
    useIsFederatedSearchEnabledButCheckingAvailability,
    useIsFederatedSearchEnabledButConfirmedUnavailable,
} from '../../federated-search/federated-search-remote-state-context';

export function DexFormButton(): React.ReactElement | null {
    const { dexNextEnabled } = useEnabledFeatures();
    const isFederatedSearchEnabledButConfirmedUnavailable = useIsFederatedSearchEnabledButConfirmedUnavailable();
    const isFederatedSearchEnabledButCheckingAvailability = useIsFederatedSearchEnabledButCheckingAvailability();

    if (isFederatedSearchEnabledButConfirmedUnavailable) {
        return null;
    }

    return (
        <WorkspacePanelButton
            tooltipText={`${getUniversalSearchFormLabel(dexNextEnabled)}`}
            workspacePanelType="DATA_EXCHANGE_FORM"
            aria-label={`open ${getUniversalSearchFormLabel(dexNextEnabled)}`}
            icon="DataExchangeInquiries"
            isDisabled={isFederatedSearchEnabledButCheckingAvailability}
        />
    );
}
